var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_c('a',{attrs:{"href":'/en/message-search/?filters=username%3A' + _vm.result + '&posted_date=desc&query=&limit=25&start=0'}},[_vm._v("Search with "+_vm._s(_vm.result))])]),_c('hr'),_c('p')])
}
var staticRenderFns = []

export { render, staticRenderFns }